import { useEffect, useState } from "react";
import Flag from "../shared/Flag";
import CdrDetails from "./CdrDetails";
import { HiOutlineTicket, HiOutlineViewList } from "react-icons/hi";

const BaseIcon = () => (
  <svg viewBox="0 0 24 24" className="w-4 h-4" fill="currentColor">
    <path d="M12 3c-4.418 0-8 1.79-8 4v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7c0-2.21-3.582-4-8-4zm0 2c3.866 0 6 .985 6 2s-2.134 2-6 2-6-.985-6-2 2.134-2 6-2zm6 5.236V12c0 1.015-2.69 2.764-6 2.764S6 13.015 6 12V10.236C7.398 11.21 9.69 11.764 12 11.764s4.602-.554 6-1.528zm0 5V17c0 1.015-2.69 2.764-6 2.764S6 18.015 6 17v-1.764C7.398 16.21 9.69 16.764 12 16.764s4.602-.554 6-1.528z"/>
  </svg>
);

const GroupIcon = () => (
  <svg viewBox="0 0 24 24" className="w-4 h-4" fill="currentColor">
    <path d="M7 10a3 3 0 110-6 3 3 0 010 6zm10 0a3 3 0 110-6 3 3 0 010 6zM7 12c-2.761 0-5 2.239-5 5v2h6v-2c0-.7.12-1.37.34-2H7zm10 0h-.34c.22.63.34 1.3.34 2v2h6v-2c0-2.761-2.239-5-5-5zM12 11a4 4 0 014 4v4H8v-4a4 4 0 014-4z"/>
  </svg>
);

// 🔽 pequeño Badge reutilizable
const Badge = ({ children, title, tone = "slate" }) => (
  <span
    title={title}
    className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full
      bg-${tone}-100 text-${tone}-800 dark:bg-${tone}-900/30 dark:text-${tone}-300
      max-w-[12rem] truncate`}
  >
    {children}
  </span>
);
const formatToLocalTime = (date) => {
  const timestamp = new Date(date);
  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  return timestamp.toLocaleString(undefined, {
    timeZone: userTimeZone,
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
  });
};

// components/StarIcon.jsx
const StarIcon = ({ active = false, half = false }) => {
  return (
    <div className="relative w-5 h-5">
      {/* Fondo gris claro por defecto */}
      <svg className="w-5 h-5 text-gray-300" viewBox="0 0 24 24" fill="none">
        <path
          d="M11.2691 4.41115C11.5006 3.89177 11.6164 3.63208 11.7776 3.55211C11.9176 3.48263 12.082 3.48263 12.222 3.55211C12.3832 3.63208 12.499 3.89177 12.7305 4.41115L14.5745 8.54808C14.643 8.70162 14.6772 8.77839 14.7302 8.83718C14.777 8.8892 14.8343 8.93081 14.8982 8.95929C14.9705 8.99149 15.0541 9.00031 15.2213 9.01795L19.7256 9.49336C20.2911 9.55304 20.5738 9.58288 20.6997 9.71147C20.809 9.82316 20.8598 9.97956 20.837 10.1342C20.8108 10.3122 20.5996 10.5025 20.1772 10.8832L16.8125 13.9154C16.6877 14.0279 16.6252 14.0842 16.5857 14.1527C16.5507 14.2134 16.5288 14.2807 16.5215 14.3503C16.5132 14.429 16.5306 14.5112 16.5655 14.6757L17.5053 19.1064C17.6233 19.6627 17.6823 19.9408 17.5989 20.1002C17.5264 20.2388 17.3934 20.3354 17.2393 20.3615C17.0619 20.3915 16.8156 20.2495 16.323 19.9654L12.3995 17.7024C12.2539 17.6184 12.1811 17.5765 12.1037 17.56C12.0352 17.5455 11.9644 17.5455 11.8959 17.56C11.8185 17.5765 11.7457 17.6184 11.6001 17.7024L7.67662 19.9654C7.18404 20.2495 6.93775 20.3915 6.76034 20.3615C6.60623 20.3354 6.47319 20.2388 6.40075 20.1002C6.31736 19.9408 6.37635 19.6627 6.49434 19.1064L7.4341 14.6757C7.46898 14.5112 7.48642 14.429 7.47814 14.3503C7.47081 14.2807 7.44894 14.2134 7.41394 14.1527C7.37439 14.0842 7.31195 14.0279 7.18708 13.9154L3.82246 10.8832C3.40005 10.5025 3.18884 10.3122 3.16258 10.1342C3.13978 9.97956 3.19059 9.82316 3.29993 9.71147C3.42581 9.58288 3.70856 9.55304 4.27406 9.49336L8.77835 9.01795C8.94553 9.00031 9.02911 8.99149 9.10139 8.95929C9.16534 8.93081 9.2226 8.8892 9.26946 8.83718C9.32241 8.77839 9.35663 8.70162 9.42508 8.54808L11.2691 4.41115Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>

      {(active || half) && (
        <div
          className={`absolute inset-0 ${
            half ? "w-1/2 overflow-hidden" : ""
          } text-yellow-400`}
        >
          <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none">
            <path
              d="M11.2691 4.41115C11.5006 3.89177 11.6164 3.63208 11.7776 3.55211C11.9176 3.48263 12.082 3.48263 12.222 3.55211C12.3832 3.63208 12.499 3.89177 12.7305 4.41115L14.5745 8.54808C14.643 8.70162 14.6772 8.77839 14.7302 8.83718C14.777 8.8892 14.8343 8.93081 14.8982 8.95929C14.9705 8.99149 15.0541 9.00031 15.2213 9.01795L19.7256 9.49336C20.2911 9.55304 20.5738 9.58288 20.6997 9.71147C20.809 9.82316 20.8598 9.97956 20.837 10.1342C20.8108 10.3122 20.5996 10.5025 20.1772 10.8832L16.8125 13.9154C16.6877 14.0279 16.6252 14.0842 16.5857 14.1527C16.5507 14.2134 16.5288 14.2807 16.5215 14.3503C16.5132 14.429 16.5306 14.5112 16.5655 14.6757L17.5053 19.1064C17.6233 19.6627 17.6823 19.9408 17.5989 20.1002C17.5264 20.2388 17.3934 20.3354 17.2393 20.3615C17.0619 20.3915 16.8156 20.2495 16.323 19.9654L12.3995 17.7024C12.2539 17.6184 12.1811 17.5765 12.1037 17.56C12.0352 17.5455 11.9644 17.5455 11.8959 17.56C11.8185 17.5765 11.7457 17.6184 11.6001 17.7024L7.67662 19.9654C7.18404 20.2495 6.93775 20.3915 6.76034 20.3615C6.60623 20.3354 6.47319 20.2388 6.40075 20.1002C6.31736 19.9408 6.37635 19.6627 6.49434 19.1064L7.4341 14.6757C7.46898 14.5112 7.48642 14.429 7.47814 14.3503C7.47081 14.2807 7.44894 14.2134 7.41394 14.1527C7.37439 14.0842 7.31195 14.0279 7.18708 13.9154L3.82246 10.8832C3.40005 10.5025 3.18884 10.3122 3.16258 10.1342C3.13978 9.97956 3.19059 9.82316 3.29993 9.71147C3.42581 9.58288 3.70856 9.55304 4.27406 9.49336L8.77835 9.01795C8.94553 9.00031 9.02911 8.99149 9.10139 8.95929C9.16534 8.93081 9.2226 8.8892 9.26946 8.83718C9.32241 8.77839 9.35663 8.70162 9.42508 8.54808L11.2691 4.41115Z"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      )}
    </div>
  );
};

const formatDuration = (value, isMilliseconds = false) => {
  if (!value) return "00:00";

  const totalSeconds = isMilliseconds ? Math.floor(value / 1000) : value;

  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes.toString().padStart(2, "0")}:${seconds
    .toString()
    .padStart(2, "0")}`;
};

const CdrTable = ({
  data,
  loading,
  error,
  sortBy,
  sortOrder,
  onSort,
}) => {
  const [rowHeight, setRowHeight] = useState(0);
  const [modalContent, setModalContent] = useState(null);

   const [showMoove, setShowMoove] = useState(false);
  useEffect(() => {
    try {
      const value = typeof window !== "undefined" ? localStorage.getItem("CN") : null;
      setShowMoove(value === "MooveCars");
    } catch (e) {
      setShowMoove(false);
    }
  }, []);

  const openModal = (component) => {
    setModalContent(component);
  };

  const closeModal = () => {
    setModalContent(null);
  };
  useEffect(() => {
    const calculateRowHeight = () => {
      const totalTableHeight = window.innerHeight * 0.8 - 16; // 80vh menos 1rem (16px)
      const headerHeight = window.innerHeight * 0.033; // ~3vh para el encabezado
      const availableHeight = totalTableHeight - headerHeight;
      setRowHeight(Math.floor(availableHeight / 15)); // Dividir entre 15 filas
    };

    calculateRowHeight();
    window.addEventListener("resize", calculateRowHeight);

    return () => window.removeEventListener("resize", calculateRowHeight);
  }, []);

  return (
    <div className="max-h-full overflow-auto bg-white dark:bg-gray-800 rounded-md border border-gray-200 dark:border-gray-700 shadow-md">
      <table className="w-full table-fixed">
       <thead
          className="
            sticky top-0 z-10
            bg-gray-200 dark:bg-gray-700
            shadow-sm
            text-gray-700 dark:text-gray-300
            text-[11px] sm:text-xs
            uppercase tracking-wide
            rounded-t-lg
          "
        >
          <tr>
            {[
              {
                label: "Init Date",
                field: "initDate",
                sortable: true,
              },
              {
                label: "Direction",
                field: "direction",
                sortable: true,
              },
              {
                label: "Source",
                field: "srcNumber",
                sortable: true,
              },
              {
                label: "Destination",
                field: "dstNumber",
                sortable: true,
              },
              {
                label: "Call Result",
                field: "callResult",
                sortable: true,
              },
              {
                label: "Queue",
                field: "queueName",
                sortable: true,
              },
              {
                label: "Agent",
                field: "agent",
                sortable: true,
              },
              {
                label: "Extension",
                field: "agentExtension",
                sortable: true,
              },

              ...(showMoove
                ? [
                    {
                      label: "BASE - GROUP",
                      field: null,
                      sortable: false,
                    },
                  ]
                : []),

              {
                label: "Transfer",
                field: null,
                sortable: false,
              },
              {
                label: "Not Answering Agents",
                field: null,
                sortable: false,
              },
              {
                label: "Duration",
                field: "durationTime",
                sortable: true,
              },
              {
                label: "Who Hangup",
                field: null,
                sortable: false,
              },
              {
                label: "Sentiment",
                field: null,
                sortable: false,
              },
              {
                label: "Agent Rating",
                field: null,
                sortable: false,
              },
              {
                label: "Survey",
                field: "survey",
                sortable: true,
              },
              {
                label: "Links",
                field: null,
                sortable: false,
              },
              {
                label: "Details",
                field: null,
                sortable: false,
              },
            ].map((column, index, array) => {
              const isLastThree =
                index >= array.length - 3;

              const isActive =
                column.sortable &&
                sortBy === column.field;

              return (
                <th
                  key={column.label}
                  onClick={() => {
                    if (
                      column.sortable &&
                      column.field &&
                      onSort
                    ) {
                      onSort(column.field);
                    }
                  }}
                  title={
                    column.sortable
                      ? `Sort by ${column.label}`
                      : undefined
                  }
                  className={`
                    px-2
                    border-b
                    border-gray-300
                    font-semibold
                    h-10 md:h-12
                    select-none

                    ${
                      isLastThree
                        ? "text-center"
                        : "text-left"
                    }

                    ${
                      column.sortable
                        ? "cursor-pointer hover:bg-gray-300 dark:hover:bg-gray-600 transition-colors"
                        : ""
                    }
                  `}
                >
                  <div
                    className={`
                      flex
                      items-center
                      gap-1
                      h-full
                      whitespace-nowrap

                      ${
                        isLastThree
                          ? "justify-center"
                          : ""
                      }
                    `}
                  >
                    <span>
                      {column.label}
                    </span>

                    {column.sortable && (
                      <span
                        className={`
                          text-[12px]
                          transition-opacity

                          ${
                            isActive
                              ? "opacity-100"
                              : "opacity-25"
                          }
                        `}
                      >
                        {isActive ? (
                          sortOrder === "asc" ? (
                            "▲"
                          ) : (
                            "▼"
                          )
                        ) : (
                          "↕"
                        )}
                      </span>
                    )}
                  </div>
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr>
              <td colSpan="17" className="text-center py-10">
                <div className="flex flex-col items-center text-gray-500 dark:text-gray-400">
                  <svg
                    className="animate-spin h-8 w-8 text-gray-500 dark:text-gray-400"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8v8H4z"
                    ></path>
                  </svg>
                  <p className="mt-3 text-lg">Loading data, please wait...</p>
                </div>
              </td>
            </tr>
          ) : error ? (
            <tr>
              <td colSpan="17" className="text-center py-10">
                <div className="flex flex-col items-center text-red-600">
                  <svg
                    className="h-10 w-10"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M12 8v4m0 4h.01M12 2.25C6.443 2.25 2.25 6.443 2.25 12c0 5.558 4.193 9.75 9.75 9.75s9.75-4.192 9.75-9.75C21.75 6.443 17.557 2.25 12 2.25z"
                    />
                  </svg>
                  <p className="mt-3 text-lg font-semibold">
                    Something went wrong!
                  </p>
                  <p className="text-sm">
                    Please reload the page to try again.
                  </p>
                </div>
              </td>
            </tr>
          ) : data.length === 0 ? (
            <tr>
              <td colSpan="17" className="text-center py-10">
                <div className="flex flex-col items-center text-gray-500 dark:text-gray-400">
                  <p className="mt-3 text-lg">No data to display.</p>
                  <p className="text-sm">
                    Try adjusting your filters or check back later.
                  </p>
                </div>
              </td>
            </tr>
          ) : (
            data.map((cdr, index) => (
              <tr
                key={index}
                style={{
                  height: `${rowHeight}px`,
                  minHeight: "40px",
                }}
                className={`${
                  index % 2 === 0
                    ? "bg-white dark:bg-gray-800"
                    : "bg-gray-50 dark:bg-primary-dark"
                } hover:bg-gray-100 dark:hover:bg-gray-700 transition-all duration-200`}
              >
                {/* Init Date */}
                <td className="px-2 py-2 text-gray-700 dark:text-gray-300 text-sm content-center">
                  <div className="flex gap-1 h-full">
                    {formatToLocalTime(cdr.initDate)}
                  </div>
                </td>
                {/* Direction */}
                <td className="px-2 py-2 text-gray-700 dark:text-gray-300 text-sm content-center">
                  <div className="flex gap-1 h-full">{cdr.direction}</div>
                </td>
                {/* Source */}
                <td className="px-2 py-2 text-gray-700 dark:text-gray-300 text-sm content-center">
                  <div className=" h-full gap-1 flex">
                    <Flag
                      code={cdr.srcIsoCode}
                      className="mr-2"
                      number={
                        showMoove
                          ? cdr.srcType === "agent"
                            ? cdr.srcNumber
                            : undefined
                          : cdr.srcNumber
                      }
                    />
                    <div>
                      {cdr.srcNumber}
                      <div className="text-gray-400 text-xs">
                        {cdr.srcIsoDescription}
                      </div>
                    </div>
                  </div>
                </td>
                {/* Destination */}
                <td className="px-2 py-2 text-gray-700 dark:text-gray-300 text-sm content-center">
                  <div className="h-full gap-1 flex">
                    <Flag code={cdr.dstIsoCode} className="mr-2" />
                    <div>
                      {cdr.dstNumber}
                      <div className="text-gray-400 text-xs">
                        {cdr.dstIsoDescription}
                      </div>
                    </div>
                  </div>
                </td>
                {/* Call Result */}
                <td className="px-2 py-2 text-gray-700 dark:text-gray-300 text-sm content-center">
                  <div className="flex gap-1 h-full">
                    <div
                      className={`h-2 w-2 rounded-full mr-2 ${
                        cdr.callResult === "Attended"
                          ? "bg-[#54B399]"
                          : cdr.callResult === "Canceled" ||
                            cdr.callResult === "Abandon"
                          ? "bg-[#6092C0]"
                          : "bg-[#9170B8]"
                      }`}
                    ></div>
                    {cdr.callResult}
                  </div>
                </td>
                {/* Queue */}
                <td className="px-2 py-2 text-gray-700 dark:text-gray-300 text-sm content-center">
                  <div className="flex gap-1 h-full">
                    {cdr.queueName?.startsWith("20")
                      ? cdr.queueName.slice(5)
                      : cdr.queueName}
                  </div>
                </td>
                {/* Agent */}
                <td className="px-2 py-2 text-gray-700 dark:text-gray-300 text-sm content-center">
                  <div className="flex gap-1 h-full">{cdr.agent || "N/A"}</div>
                </td>

                {/* Extension */}
                <td className="px-2 py-2 text-gray-700 dark:text-gray-300 text-sm content-center">
                  <div className="flex gap-1 h-full">{cdr.agentExtension || "N/A"}</div>
                </td>
                {showMoove && (
                  <td className="px-2 py-2 text-gray-700 dark:text-gray-300 text-sm content-center">
                    <div className="flex items-center gap-2 h-full">
                      {cdr.moovecars_base ? (
                        <Badge title={`Base: ${cdr.moovecars_base}`} tone="blue">
                          <BaseIcon />
                          <span className="truncate">{cdr.moovecars_base}</span>
                        </Badge>
                      ) : null}
                      {cdr.moovecars_group ? (
                        <Badge title={`Group: ${cdr.moovecars_group}`} tone="emerald">
                          <GroupIcon />
                          <span className="truncate">{cdr.moovecars_group}</span>
                        </Badge>
                      ) : null}

                      {!cdr.moovecars_base && !cdr.moovecars_group && (
                        <span className="text-gray-400">N/A</span>
                      )}
                    </div>
                  </td>
                )}


                 {/* Transfer */}
                <td className="px-2 py-2 text-gray-700 dark:text-gray-300 text-sm content-center">
                  {cdr.transfered ? (
                    <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300">
                      <span className="text-xs">→</span>
                      <span className="truncate max-w-[10rem]" title={cdr.agentTransfered}>
                        {cdr.agentTransfered}
                      </span>
                    </span>
                  ) : (
                    <span className="text-gray-400">No</span>
                  )}
                </td>

                <td className="px-2 py-2 text-gray-700 dark:text-gray-300 text-sm relative group content-center">
                  <div className="flex gap-1 h-full">
                    {cdr.notAnsweringAgents?.length > 0 ? (
                      <>
                        <div className="flex items-center -space-x-2">
                          {cdr.notAnsweringAgents
                            .slice(0, 3)
                            .map((agentObj, i) => (
                              <div
                                key={i}
                                className="h-8 w-8 bg-gray-500 text-white rounded-full flex items-center justify-center text-xs font-semibold"
                              >
                                {agentObj.agent
                                  .split(" ")
                                  .slice(0, 2)
                                  .map((word) => word[0])
                                  .join("")}
                              </div>
                            ))}
                          {cdr.notAnsweringAgents.length > 3 && (
                            <div className="h-8 w-8 bg-gray-500 text-white rounded-full flex items-center justify-center text-xs font-semibold">
                              +{cdr.notAnsweringAgents.length - 3}
                            </div>
                          )}
                        </div>
                        {/* Tooltip */}
                        <div className="absolute top-0 left-0 w-full h-full hidden group-hover:block">
                          <div
                            style={{
                              top: index <= 7 ? "3rem" : "auto",
                              bottom: index > 7 ? "3rem" : "auto",
                            }}
                            className={`z-10 absolute ${
                              index <= 7 ? "top-12" : "bottom-12"
                            } left-1/2 -translate-x-1/2 p-2 bg-gray-700 text-white text-sm rounded shadow-lg min-w-[150px] w-[250px] max-w-[500px]`}
                          >
                            {cdr.notAnsweringAgents.map((agentObj, i) => (
                              <div key={i}>
                                {`${i + 1}. ${agentObj.agent} - ${Math.floor(
                                  agentObj.ringingTime / 60000
                                )
                                  .toString()
                                  .padStart(2, "0")}:${Math.floor(
                                  (agentObj.ringingTime % 60000) / 1000
                                )
                                  .toString()
                                  .padStart(2, "0")}`}
                              </div>
                            ))}
                          </div>
                        </div>
                      </>
                    ) : (
                      <span className="text-gray-400">N/A</span>
                    )}
                  </div>
                </td>

                {/* Duration */}
                <td className="px-2 py-2 text-gray-700 dark:text-gray-300 text-sm content-center">
                  <div className="flex gap-1 h-full">
                    {formatDuration(cdr.durationTime)}
                  </div>
                </td>
                {/* Who Hangup */}
                <td className="px-2 py-2 text-gray-700 dark:text-gray-300 text-sm content-center">
                  <div className="flex gap-1">{cdr.whoHangup}</div>
                </td>
                {/* Sentiment */}
                <td className="px-2 py-1 text-gray-700 dark:text-gray-300 text-sm content-center ">
                  <div className="flex gap-1 justify-center text-center">
                    {cdr.sentiment === "positive" && (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="w-6 h-6 text-green-700"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          xmlns="http://www.w3.org/2000/svg"
                          d="M8 14C8 14 9.5 16 12 16C14.5 16 16 14 16 14M15 9H15.01M9 9H9.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM15.5 9C15.5 9.27614 15.2761 9.5 15 9.5C14.7239 9.5 14.5 9.27614 14.5 9C14.5 8.72386 14.7239 8.5 15 8.5C15.2761 8.5 15.5 8.72386 15.5 9ZM9.5 9C9.5 9.27614 9.27614 9.5 9 9.5C8.72386 9.5 8.5 9.27614 8.5 9C8.5 8.72386 8.72386 8.5 9 8.5C9.27614 8.5 9.5 8.72386 9.5 9Z"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    )}
                    {cdr.sentiment === "neutral" && (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="w-6 h-6 text-gray-600"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          xmlns="http://www.w3.org/2000/svg"
                          d="M8 15H16M15 9H15.01M9 9H9.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM15.5 9C15.5 9.27614 15.2761 9.5 15 9.5C14.7239 9.5 14.5 9.27614 14.5 9C14.5 8.72386 14.7239 8.5 15 8.5C15.2761 8.5 15.5 8.72386 15.5 9ZM9.5 9C9.5 9.27614 9.27614 9.5 9 9.5C8.72386 9.5 8.5 9.27614 8.5 9C8.5 8.72386 8.72386 8.5 9 8.5C9.27614 8.5 9.5 8.72386 9.5 9Z"
                          stroke-width="2"
                          stroke="currentColor"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    )}
                    {cdr.sentiment === "negative" && (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="w-6 h-6 text-red-700"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          xmlns="http://www.w3.org/2000/svg"
                          d="M16 16C16 16 14.5 14 12 14C9.5 14 8 16 8 16M15 9H15.01M9 9H9.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM15.5 9C15.5 9.27614 15.2761 9.5 15 9.5C14.7239 9.5 14.5 9.27614 14.5 9C14.5 8.72386 14.7239 8.5 15 8.5C15.2761 8.5 15.5 8.72386 15.5 9ZM9.5 9C9.5 9.27614 9.27614 9.5 9 9.5C8.72386 9.5 8.5 9.27614 8.5 9C8.5 8.72386 8.72386 8.5 9 8.5C9.27614 8.5 9.5 8.72386 9.5 9Z"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    )}
                  </div>
                </td>

                {/* Agent Rating */}
                <td className="px-2 py-1 text-gray-700 dark:text-gray-300 text-sm content-center justify-center">
                  <div className="flex gap-1 h-full text-center justify-center">
                    {!isNaN(parseFloat(cdr.agentValue)) ? (
                      <div className="flex items-center space-x-1">
                        {[...Array(5)].map((_, i) => {
                          const value = parseFloat(cdr.agentValue);
                          const full = i + 1 <= value;
                          const half = !full && value > i && value < i + 1;

                          return <StarIcon key={i} active={full} half={half} />;
                        })}
                      </div>
                    ) : (
                      <span className="text-gray-400">N/A</span>
                    )}
                  </div>
                </td>

                {/* Survey */}
                <td className="px-2 py-1 text-sm content-center text-center relative group">
                  {Array.isArray(cdr.survey) && cdr.survey.length > 0 ? (
                    <>
                      <button
                        type="button"
                        className="inline-flex items-center gap-1 h-8 px-2 rounded-xl bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-300"
                        title="Ver encuesta"
                      >
                        <svg viewBox="0 0 20 20" className="w-4 h-4" fill="currentColor">
                          <path d="M10 2a8 8 0 100 16 8 8 0 000-16zm1 11H9v-2h2v2zm0-4H9V5h2v4z" />
                        </svg>
                        Survey
                      </button>

                      {/* Tooltip */}
                      <div className="hidden group-hover:block absolute z-10 left-1/2 -translate-x-1/2 mt-2 p-2 rounded-md shadow-lg bg-gray-700 text-white text-xs w-[220px]">
                        <ul className="space-y-1 text-left">
                          {cdr.survey.map((q, i) => (
                            <li key={i} className="flex justify-between gap-2">
                              <span className="truncate max-w-[150px]" title={q.titulo}>{q.titulo}</span>
                              <span className="font-semibold">{q.nota}</span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </>
                  ) : (
                    <span className="text-gray-400">N/A</span>
                  )}
                </td>


                {/* Links */}
                <td className="px-2 py-1 text-sm content-center text-center">
                  {cdr.ticket_url ? (
                    <a
                      href={cdr.ticket_url}
                      target="_blank"
                      rel="noopener noreferrer"
                      title="Open ticket"
                      className="inline-flex items-center justify-center h-8 w-8 rounded-xl bg-[#E5E7EB] dark:bg-secondary-dark hover:brightness-95 transition"
                    >
                      <HiOutlineTicket className="h-5 w-5 text-text-primary-light dark:text-text-primary-dark" />
                    </a>
                  ) : null}
                </td>

                {/* Actions */}
                <td className="px-2 py-1 text-text-primary-light dark:text-text-primary-dark text-sm content-center text-center">
                  <div className="flex gap-1 h-full text-center justify-center">
                    {/* Details Button */}
                    <div
                      className="h-8 w-8 bg-[#E5E7EB] dark:bg-secondary-dark dark:text-white rounded-xl flex items-center justify-center bg-[#E5E7EB]/90 cursor-pointer"
                      title="Details"
                      onClick={() => openModal(<CdrDetails call={cdr} />)}
                    >
                      <HiOutlineViewList className="h-5 w-5 text-text-primary-light dark:text-text-primary-dark" />
                    </div>
                  </div>
                  {/* Play Button */}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
      {/* Modal */}
      {modalContent && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm flex justify-center items-center z-50"
          onClick={closeModal}
        >
          <div
            className="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-6 w-3/5 relative"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={closeModal}
              className="absolute top-2 right-2 text-gray-500 hover:text-gray-700 dark:text-gray-300 dark:hover:text-white"
            >
              ×
            </button>
            {modalContent}
          </div>
        </div>
      )}
    </div>
  );
};

export default CdrTable;
